import React from 'react'

const Norms = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Norms set for discharge of functions</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify'}}>
      <p>Norms as per the Memorandum & Articles of Association/Companies Act, 1956 or as approved by the Board of Directors are the guiding principles for discharging various functions.</p>
    </div>
    </div>
  )
}

export default Norms
